import { render, staticRenderFns } from "./openSeaCabinSpace.vue?vue&type=template&id=1c81bef7&"
import script from "./openSeaCabinSpace.vue?vue&type=script&lang=js&"
export * from "./openSeaCabinSpace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c81bef7')) {
      api.createRecord('1c81bef7', component.options)
    } else {
      api.reload('1c81bef7', component.options)
    }
    module.hot.accept("./openSeaCabinSpace.vue?vue&type=template&id=1c81bef7&", function () {
      api.rerender('1c81bef7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Sales/openSeaCabinSpace.vue"
export default component.exports